import type { InputHTMLAttributes } from 'react';

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
    post?: string;
};

export function Input({ className = '', post = '', ...props }: InputProps) {
    const color = 'bg-white/90 text-foreground border border-foreground/15 focus:border-primary/50 focus:ring-2 focus:ring-primary/30';

    return (
        <>
            <input {...props} className={`block w-full rounded-xl ${post && 'rounded-r-none'} px-5 py-3 text-sm font-medium placeholder:text-secondary/50 outline-none transition disabled:opacity-60 disabled:cursor-not-allowed disabled:pointer-events-none ${color} ${className}`} />
            {!!post && <div className="h-full flex items-center px-3 py-0 border border-l-0 border-foreground/15 rounded-r-full bg-muted/60 text-xs font-semibold tracking-wide text-secondary">{post}</div>}
        </>
    );
}
